import type { TFunction } from "i18next";
import { validateNumberRangeCounterStartValue } from "../../../../../mantine/mrt/validation/validateCounterStartValue";
import { validateNumberRangeFormat } from "../../../../../mantine/mrt/validation/validateNumberRangeFormat";
import type { Paragraph6CreditNumberRangeFormValues } from "../../Paragraph6CreditNumberRangesPage.types";
import { isFormatValid } from "./isFormatValid";

/** MRT _valuesCache holds Date objects for valid_from (from accessorFn),
 * not the backend string type. This type reflects the actual cache shape. */
type CreditNumberRangeCacheValues = Omit<
  Paragraph6CreditNumberRangeFormValues,
  "valid_from"
> & {
  valid_from: Date | null;
};

/** Validates form values from a row in Paragraph6CreditNumberRangesTable. */
export function validateParagraph6CreditNumberRangeFormValues(
  range: Partial<CreditNumberRangeCacheValues>,
  t: TFunction
) {
  return {
    supplier: !isRequiredNumberValid(range.supplier)
      ? t("errors.Required")
      : "",
    format: validateNumberRangeFormat(range.format, isFormatValid, {
      required: t("errors.Required"),
      invalidFormat: t("errors.NumberRanges.formatError")
    }),
    counter_start_value: validateNumberRangeCounterStartValue(
      range.counter_start_value,
      t
    ),
    valid_from: !(range.valid_from instanceof Date) ? t("errors.Required") : ""
  };
}

function isRequiredNumberValid(
  value: number | null | undefined
): value is number {
  return typeof value !== "undefined" && value !== null;
}
